<template>
  <v-abstract-menu-option>
    <template
      #info
    >Mostrar solo clasificaciones pendientes: {{ showOnlyPendingClassifications ? 'Sí' : 'No' }}</template>
    <template #input>
      <v-card>
        <v-container class="px-3 py-1">
          <v-layout justify-center>
            <v-flex shrink>
              <v-switch
                v-model="model"
                label="Ver solo clasificaciones que tienen QMIs por matchear"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </template>
  </v-abstract-menu-option>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations, mapState } = createNamespacedHelpers("matching");

import VAbstractMenuOption from "@/components/settings-menu/AbstractMenuOption";

export default {
  components: {
    VAbstractMenuOption
  },
  computed: {
    ...mapState(["showOnlyPendingClassifications"]),
    model: {
      get() {
        return this.showOnlyPendingClassifications;
      },
      set(show) {
        this.setShowOnlyPendingClassifications(show);
      }
    }
  },
  methods: {
    ...mapMutations(["setShowOnlyPendingClassifications"])
  }
};
</script>